var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStrax(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.635 1.675a1.138 1.138 0 0 0-1.21-.001l-14.406 9.05c-.32.202-.52.552-.52.934v3.974c0 .38.197.728.514.93l14.405 9.16c.363.232.83.237 1.198.013l12.634-7.678v1.108l-13.225 8.343-13.799-8.67a1.134 1.134 0 0 0-1.545.327c-.345.52-.186 1.21.336 1.54l14.404 9.05c.37.232.842.231 1.21-.001l14.348-9.051c.32-.201.518-.55.518-.932v-3.697c0-.41-.228-.78-.584-.97a1.138 1.138 0 0 0-1.13.028l-13.744 8.354-13.294-8.455V13.63l12.695 7.637c.36.217.813.217 1.173 0l14.348-8.665c.326-.197.532-.548.536-.933a1.103 1.103 0 0 0-.518-.944L16.635 1.675zm-.608 17.35-12.28-7.387 12.28-7.717 12.233 7.717-12.233 7.388z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStrax);
export default __webpack_public_path__ + "static/media/STRAX.e11b79e8d271a8519371cdd5ec19d299.svg";
export { ForwardRef as ReactComponent };